import React from 'react';
import { Menu, MenuItem, ListItemText } from '@mui/material';
import { isMobile } from 'utils/device';

interface OutputFormatMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onSelect: (format: string) => void;
}

const OutputFormatMenu: React.FC<OutputFormatMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onSelect,
}) => {
  const formatOptions = [
    { value: 'list', label: 'List' },
    { value: 'table', label: 'Table' },
    { value: 'memo', label: 'Memo' },
    { value: 'briefing', label: 'Briefing' },
    { value: 'freeform', label: 'Free Form' },
    { value: 'chronology', label: 'Chronology' },
  ];

  const handleMenuItemClick = (format: string) => {
    onSelect(format);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{ 
        maxWidth: isMobile ? '90vw' : '200px',
        '& .MuiPaper-root': {
          marginTop: '-8px', // Small offset to appear just above the chip
        }
      }}
      slotProps={{
        paper: {
          style: {
            maxHeight: '70vh', // Limit height to prevent cutoff
          },
        },
      }}
    >
      {formatOptions.map((option) => (
        <MenuItem
          key={option.value}
          onClick={() => handleMenuItemClick(option.value)}
          sx={{
            minWidth: '120px',
          }}
        >
          <ListItemText primary={option.label} />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default OutputFormatMenu;
